import { render, staticRenderFns } from "./ModalVideo.vue?vue&type=template&id=7bd565e5"
import script from "./ModalVideo.vue?vue&type=script&lang=ts"
export * from "./ModalVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports